// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VMYk","comment":"styles_comment__3HCpM"};